/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents the type of an organization meeting location.
 */
export enum OrganizationMeetingLocationType {
  IN_PERSON = "IN_PERSON",
  ONLINE = "ONLINE",
}
